import React from 'react';
import { motion } from 'framer-motion';
import { Hero } from '../components/Hero';
import { Section, SectionTitle, SectionSubtitle } from '../components/Section';
import { FeatureList } from '../components/FeatureList';
import { CTAButton } from '../components/CTAButton';
import { LanguageModal } from '../components/LanguageModal';
import { PricingSection } from '../components/PricingSection';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
import { useLanguage } from '../context/LanguageContext';
export function LandingPage() {
  const {
    t,
    language
  } = useLanguage();
  return <main className="bg-matrix-bg min-h-screen overflow-x-hidden relative px-[10px]" data-id="element-237">
      <LanguageModal data-id="element-238" />
      <RecentPurchaseToast data-id="element-239" />
      <Hero data-id="element-240" />

      {/* LA VIDA DOBLE DEL "DESPIERTO A MEDIAS" */}
      <Section className="bg-matrix-bg-light" data-id="element-241">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-242">
          <SectionTitle data-id="element-243">{t.doubleLife.title}</SectionTitle>

          <p className="text-white text-lg mb-6" data-id="element-244">{t.doubleLife.intro}</p>

          <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-245">
            <div className="bg-matrix-bg/50 p-5 rounded-xl border border-matrix-muted/20" data-id="element-246">
              <SectionSubtitle className="text-white" data-id="element-247">
                {t.doubleLife.externalTitle}
              </SectionSubtitle>
              <FeatureList items={t.doubleLife.externalItems} data-id="element-248" />
              <p className="text-white mt-3 italic" data-id="element-249">
                {t.doubleLife.externalNote}
              </p>
            </div>

            <div className="bg-matrix-bg/50 p-5 rounded-xl border border-matrix-accent/20" data-id="element-250">
              <SectionSubtitle className="text-matrix-accent" data-id="element-251">
                {t.doubleLife.internalTitle}
              </SectionSubtitle>
              <FeatureList items={t.doubleLife.internalItems} data-id="element-252" />
            </div>
          </div>

          <div className="text-center space-y-3 text-white text-lg" data-id="element-253">
            <p className="font-semibold" data-id="element-254">{t.doubleLife.however}</p>
            <p data-id="element-255">{t.doubleLife.whenClose}</p>
            <p className="text-matrix-accent font-bold text-xl" data-id="element-256">
              {t.doubleLife.realityStays}
            </p>
            <p data-id="element-257">{t.doubleLife.samePatterns}</p>
            <p className="italic" data-id="element-258">{t.doubleLife.hurts}</p>
          </div>
        </div>
      </Section>

      {/* NO ESTÁS ROTO. ESTÁS PROGRAMADO. */}
      <Section data-id="element-259">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-260">
          <SectionTitle data-id="element-261">{t.programmed.title}</SectionTitle>

          <p className="text-white text-lg mb-5" data-id="element-262">{t.programmed.intro}</p>

          <div className="bg-matrix-bg-light p-5 rounded-xl mb-6 border-l-4 border-matrix-muted" data-id="element-263">
            <FeatureList variant="default" items={t.programmed.systemSays} className="text-white italic" data-id="element-264" />
          </div>

          <p className="text-white text-lg mb-5" data-id="element-265">{t.programmed.repeated}</p>
          <p className="text-white text-lg mb-6" data-id="element-266">{t.programmed.becameNormal}</p>

          <SectionSubtitle data-id="element-267">{t.programmed.programmedForTitle}</SectionSubtitle>
          <FeatureList items={t.programmed.programmedForItems} className="mb-6" data-id="element-268" />

          <div className="bg-gradient-to-r from-matrix-accent/10 to-matrix-accent-secondary/10 p-6 rounded-xl border border-matrix-accent/30" data-id="element-269">
            <p className="text-white text-lg font-semibold mb-2" data-id="element-270">
              {t.programmed.truthIs}
            </p>
            <p className="text-matrix-accent text-xl md:text-2xl font-bold" data-id="element-271">
              {t.programmed.notBlocked}
            </p>
          </div>
        </div>
      </Section>

      {/* YA NO TE FALTA CONTENIDO. TE FALTA UN MAPA. */}
      <Section className="bg-matrix-bg-light" data-id="element-272">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-273">
          <SectionTitle data-id="element-274">{t.needMap.title}</SectionTitle>

          <p className="text-white text-lg mb-5" data-id="element-275">{t.needMap.seenEverything}</p>
          <FeatureList items={t.needMap.seenItems} className="mb-6" data-id="element-276" />

          <p className="text-white text-lg font-medium mb-5" data-id="element-277">
            {t.needMap.youKnow}
          </p>
          <p className="text-white text-lg mb-6" data-id="element-278">{t.needMap.butNoOne}</p>

          <div className="space-y-3 mb-6" data-id="element-279">
            {t.needMap.quotes.map((quote, index) => <div key={index} className="bg-matrix-bg p-4 rounded-lg border-l-4 border-matrix-accent" data-id="element-280">
                <p className="text-white italic" data-id="element-281">{quote}</p>
              </div>)}
          </div>

          <p className="text-white text-lg mb-3" data-id="element-282">{t.needMap.marathons}</p>
          <p className="text-matrix-accent text-xl font-bold mb-6" data-id="element-283">
            {t.needMap.knowTooMuch}
          </p>
          <p className="text-white text-lg mb-6" data-id="element-284">{t.needMap.needProtocol}</p>

          <p className="text-white text-lg font-medium mb-4" data-id="element-285">
            {t.needMap.enterHere}
          </p>

          <div className="bg-gradient-to-r from-matrix-accent/10 to-matrix-accent-secondary/10 p-6 rounded-xl border border-matrix-accent/30" data-id="element-286">
            <p className="text-white text-lg font-semibold mb-2" data-id="element-287">
              {t.programmed.truthIs}
            </p>
            <p className="text-matrix-accent text-xl md:text-2xl font-bold" data-id="element-288">
              {t.programmed.notBlocked}
            </p>
          </div>
        </div>
      </Section>

      {/* Target Audience */}
      <Section data-id="element-289">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-290">
          <p className="text-white text-lg mb-5" data-id="element-291">{t.targetAudience.notPdf}</p>
          <p className="text-white text-lg font-medium mb-5" data-id="element-292">
            {t.targetAudience.designedFor}
          </p>
          <FeatureList items={t.targetAudience.items} data-id="element-293" />
        </div>
      </Section>

      {/* EL MECANISMO QUE NADIE TE EXPLICÓ */}
      <Section className="bg-matrix-bg-light" data-id="element-294">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-295">
          <SectionTitle data-id="element-296">{t.mechanism.title}</SectionTitle>

          <p className="text-white text-lg mb-3" data-id="element-297">{t.mechanism.rootProblem}</p>
          <p className="text-matrix-accent text-xl font-bold mb-6" data-id="element-298">
            {t.mechanism.rootIs}
          </p>

          <p className="text-white text-lg mb-3" data-id="element-299">{t.mechanism.osIs}</p>
          <p className="text-white text-xl font-semibold mb-6" data-id="element-300">
            {t.mechanism.formula}
          </p>
          <p className="text-white text-lg mb-6" data-id="element-301">{t.mechanism.ifNotRewrite}</p>

          <p className="text-white text-lg mb-6" data-id="element-302">{t.mechanism.showsHow}</p>

          <div className="grid md:grid-cols-3 gap-5 mb-6" data-id="element-303">
            <motion.div className="bg-matrix-bg p-5 rounded-xl border border-matrix-accent/30" whileInView={{
            opacity: 1,
            y: 0
          }} initial={{
            opacity: 0,
            y: 20
          }} transition={{
            delay: 0.1
          }} data-id="element-304">
              <div className="text-5xl font-black text-matrix-accent text-glow mb-3" data-id="element-305">
                {t.mechanism.three.number}
              </div>
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-306">
                {t.mechanism.three.title}
              </h4>
              <p className="text-white mb-3" data-id="element-307">{t.mechanism.three.desc}</p>
              <FeatureList items={t.mechanism.three.items} data-id="element-308" />
            </motion.div>

            <motion.div className="bg-matrix-bg p-5 rounded-xl border border-matrix-accent/30" whileInView={{
            opacity: 1,
            y: 0
          }} initial={{
            opacity: 0,
            y: 20
          }} transition={{
            delay: 0.2
          }} data-id="element-309">
              <div className="text-5xl font-black text-matrix-accent text-glow mb-3" data-id="element-310">
                {t.mechanism.six.number}
              </div>
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-311">
                {t.mechanism.six.title}
              </h4>
              <p className="text-white mb-3" data-id="element-312">{t.mechanism.six.desc}</p>
              <FeatureList items={t.mechanism.six.items} data-id="element-313" />
            </motion.div>

            <motion.div className="bg-matrix-bg p-5 rounded-xl border border-matrix-accent/30" whileInView={{
            opacity: 1,
            y: 0
          }} initial={{
            opacity: 0,
            y: 20
          }} transition={{
            delay: 0.3
          }} data-id="element-314">
              <div className="text-5xl font-black text-matrix-accent text-glow mb-3" data-id="element-315">
                {t.mechanism.nine.number}
              </div>
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-316">
                {t.mechanism.nine.title}
              </h4>
              <p className="text-white mb-3" data-id="element-317">{t.mechanism.nine.desc}</p>
              <FeatureList items={t.mechanism.nine.items} data-id="element-318" />
            </motion.div>
          </div>

          <p className="text-matrix-accent text-xl font-bold text-center" data-id="element-319">
            {t.mechanism.stopWriting}
          </p>
        </div>
      </Section>

      {/* 3 METÁFORAS */}
      <Section data-id="element-320">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-321">
          <SectionTitle data-id="element-322">{t.metaphors.title}</SectionTitle>

          <div className="space-y-5" data-id="element-323">
            <div className="bg-matrix-bg-light p-5 rounded-xl" data-id="element-324">
              <h4 className="text-xl font-bold text-matrix-accent mb-2" data-id="element-325">
                {t.metaphors.spotify.title}
              </h4>
              <p className="text-white" data-id="element-326">{t.metaphors.spotify.desc}</p>
            </div>

            <div className="bg-matrix-bg-light p-5 rounded-xl" data-id="element-327">
              <h4 className="text-xl font-bold text-matrix-accent mb-2" data-id="element-328">
                {t.metaphors.glitch.title}
              </h4>
              <p className="text-white" data-id="element-329">{t.metaphors.glitch.desc}</p>
            </div>

            <div className="bg-matrix-bg-light p-5 rounded-xl" data-id="element-330">
              <h4 className="text-xl font-bold text-matrix-accent mb-2" data-id="element-331">
                {t.metaphors.player.title}
              </h4>
              <p className="text-white" data-id="element-332">{t.metaphors.player.desc}</p>
            </div>
          </div>
        </div>
      </Section>

      {/* ¿QUÉ HAY DENTRO? */}
      <Section className="bg-matrix-bg-light" data-id="element-333">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-334">
          <SectionTitle data-id="element-335">{t.whatsInside.title}</SectionTitle>

          <div className="space-y-8" data-id="element-336">
            {/* Radiografía */}
            <div data-id="element-337">
              <SectionSubtitle className="text-matrix-accent" data-id="element-338">
                {t.whatsInside.radiography.title}
              </SectionSubtitle>
              <p className="text-white mb-3" data-id="element-339">
                {t.whatsInside.radiography.intro}
              </p>
              <p className="text-white mb-3" data-id="element-340">
                {t.whatsInside.radiography.desc}
              </p>
              <FeatureList items={t.whatsInside.radiography.items} data-id="element-341" />
              <p className="text-white mt-3 italic" data-id="element-342">
                {t.whatsInside.radiography.note}
              </p>
            </div>

            {/* Desprogramación */}
            <div data-id="element-343">
              <SectionSubtitle className="text-matrix-accent" data-id="element-344">
                {t.whatsInside.deprogramming.title}
              </SectionSubtitle>
              <p className="text-white mb-3" data-id="element-345">
                {t.whatsInside.deprogramming.desc}
              </p>
              <FeatureList items={t.whatsInside.deprogramming.items} data-id="element-346" />
              <p className="text-matrix-accent mt-3 font-semibold" data-id="element-347">
                {t.whatsInside.deprogramming.note}
              </p>
            </div>

            {/* El código 3-6-9 */}
            <div data-id="element-348">
              <SectionSubtitle className="text-matrix-accent" data-id="element-349">
                {t.whatsInside.code369.title}
              </SectionSubtitle>
              <p className="text-white mb-3" data-id="element-350">{t.whatsInside.code369.intro}</p>
              <p className="text-white mb-3" data-id="element-351">{t.whatsInside.code369.desc}</p>
              <FeatureList items={t.whatsInside.code369.items} data-id="element-352" />
              <p className="text-matrix-accent mt-3 font-semibold" data-id="element-353">
                {t.whatsInside.code369.note}
              </p>
            </div>

            {/* Tu cápsula */}
            <div data-id="element-354">
              <SectionSubtitle className="text-matrix-accent" data-id="element-355">
                {t.whatsInside.capsule.title}
              </SectionSubtitle>
              <p className="text-white mb-3" data-id="element-356">{t.whatsInside.capsule.desc}</p>
              <FeatureList items={t.whatsInside.capsule.items} data-id="element-357" />
              <p className="text-white mt-3 italic" data-id="element-358">
                {t.whatsInside.capsule.note}
              </p>
            </div>

            {/* Reto 21 días */}
            <div data-id="element-359">
              <SectionSubtitle className="text-matrix-accent" data-id="element-360">
                {t.whatsInside.challenge.title}
              </SectionSubtitle>
              <p className="text-white text-xl font-bold mb-3" data-id="element-361">
                {t.whatsInside.challenge.gameChanger}
              </p>
              <p className="text-white mb-3" data-id="element-362">{t.whatsInside.challenge.desc}</p>
              <FeatureList items={t.whatsInside.challenge.items} data-id="element-363" />
              <p className="text-white mt-3" data-id="element-364">
                {t.whatsInside.challenge.notImpossible}
              </p>
              <p className="text-white mt-3" data-id="element-365">
                {t.whatsInside.challenge.sameLogic}
              </p>
              <p className="text-matrix-accent text-xl font-bold mt-2" data-id="element-366">
                {t.whatsInside.challenge.formula}
              </p>
              <p className="text-white mt-3" data-id="element-367">
                {t.whatsInside.challenge.inYourFavor}
              </p>
            </div>
          </div>

          {/* Mid-page CTA */}
          <div className="text-center mt-10" data-id="element-368">
            <CTAButton size="large" href="#pricing" data-id="element-369">
              {t.whatsInside.midCta}
            </CTAButton>
          </div>
        </div>
      </Section>

      {/* ¿QUÉ PASA DESPUÉS DE 21 DÍAS? */}
      <Section data-id="element-370">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-371">
          <SectionTitle data-id="element-372">{t.after21.title}</SectionTitle>

          <p className="text-white text-lg mb-5" data-id="element-373">{t.after21.noPromise}</p>
          <p className="text-white text-lg font-medium mb-6" data-id="element-374">
            {t.after21.promiseReal}
          </p>

          <FeatureList items={t.after21.items} variant="check" className="mb-6" data-id="element-375" />

          <p className="text-matrix-accent text-xl font-bold" data-id="element-376">
            {t.after21.notBecause}
          </p>
        </div>
      </Section>

      {/* ESTE MANUAL ES PARA TI SI… */}
      <Section className="bg-matrix-bg-light" data-id="element-377">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-378">
          <div className="grid md:grid-cols-2 gap-6" data-id="element-379">
            <div data-id="element-380">
              <SectionTitle className="text-matrix-accent-secondary" data-id="element-381">
                {t.forYou.title}
              </SectionTitle>
              <FeatureList variant="check" items={t.forYou.items} data-id="element-382" />
            </div>

            <div data-id="element-383">
              <SectionTitle className="text-matrix-muted" data-id="element-384">
                {t.notForYou.title}
              </SectionTitle>
              <FeatureList items={t.notForYou.items} data-id="element-385" />
            </div>
          </div>
        </div>
      </Section>

      {/* ¿PERO DE VERDAD FUNCIONA? */}
      <Section data-id="element-386">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-387">
          <SectionTitle data-id="element-388">{t.doesItWork.title}</SectionTitle>

          <p className="text-white text-lg mb-5" data-id="element-389">{t.doesItWork.realQuestion}</p>
          <p className="text-matrix-accent text-xl font-bold mb-6" data-id="element-390">
            {t.doesItWork.areYouWilling}
          </p>

          <p className="text-white text-lg mb-3" data-id="element-391">{t.doesItWork.notMagic}</p>
          <p className="text-white text-xl font-bold mb-6" data-id="element-392">
            {t.doesItWork.worksIf}
          </p>

          <p className="text-white text-lg mb-6" data-id="element-393">{t.doesItWork.ifYou}</p>

          <p className="text-white text-lg font-medium mb-4" data-id="element-394">
            {t.doesItWork.guarantee}
          </p>
          <FeatureList variant="check" items={t.doesItWork.guaranteeItems} data-id="element-395" />
        </div>
      </Section>

      {/* ¿QUÉ RECIBES EXACTAMENTE? */}
      <Section className="bg-matrix-bg-light" data-id="element-396">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-397">
          <SectionTitle data-id="element-398">{t.whatYouReceive.title}</SectionTitle>

          <p className="text-white text-lg mb-6" data-id="element-399">{t.whatYouReceive.when}</p>

          <div className="grid md:grid-cols-2 gap-5 mb-6" data-id="element-400">
            {t.whatYouReceive.items.map((item, index) => <div key={index} className="bg-matrix-bg p-5 rounded-xl border border-matrix-accent/20" data-id="element-401">
                <div className="text-3xl mb-2" data-id="element-402">{item.emoji}</div>
                <h4 className="text-lg font-bold text-white mb-2" data-id="element-403">
                  {item.title}
                </h4>
                <p className="text-white" data-id="element-404">{item.desc}</p>
              </div>)}
          </div>

          <p className="text-white text-lg text-center" data-id="element-405">
            {t.whatYouReceive.accessible}
          </p>
        </div>
      </Section>

      {/* IMAGINA TU VIDA 21 DÍAS DESPUÉS… */}
      <Section data-id="element-406">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-407">
          <SectionTitle data-id="element-408">{t.imagine.title}</SectionTitle>

          <p className="text-white text-lg mb-5" data-id="element-409">{t.imagine.same}</p>
          <p className="text-white text-xl font-bold mb-6" data-id="element-410">
            {t.imagine.butYou}
          </p>

          <FeatureList variant="check" items={t.imagine.items} className="mb-6" data-id="element-411" />

          <p className="text-matrix-accent text-2xl font-bold text-center" data-id="element-412">
            {t.imagine.notMotivation}
          </p>
        </div>
      </Section>

      {/* PRICING SECTION */}
      <Section className="bg-matrix-bg-light" id="pricing" data-id="element-413">
        <PricingSection data-id="element-414" />
      </Section>

      {/* FINAL CTA */}
      <Section className="bg-gradient-to-b from-matrix-bg-light to-matrix-bg" data-id="element-415">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-416">
          <SectionTitle className="text-white" data-id="element-417">{t.finalCta.title}</SectionTitle>

          <p className="text-white text-lg mb-6" data-id="element-418">{t.finalCta.moment}</p>

          <p className="text-white text-lg font-medium mb-5" data-id="element-419">
            {t.finalCta.twoOptions}
          </p>

          <div className="grid md:grid-cols-2 gap-5 mb-8 max-w-3xl mx-auto" data-id="element-420">
            <div className="bg-matrix-bg p-5 rounded-xl border border-matrix-muted/30" data-id="element-421">
              <p className="text-white" data-id="element-422">{t.finalCta.option1}</p>
            </div>

            <div className="bg-gradient-to-r from-matrix-accent/10 to-matrix-accent-secondary/10 p-5 rounded-xl border border-matrix-accent/50" data-id="element-423">
              <p className="text-white font-medium" data-id="element-424">{t.finalCta.option2}</p>
            </div>
          </div>

          <p className="text-white text-lg mb-6" data-id="element-425">{t.finalCta.ifSecond}</p>

          <div className="space-y-3 text-white text-lg mb-8" data-id="element-426">
            {t.finalCta.steps.map((step, index) => <p key={index} className={index === t.finalCta.steps.length - 1 ? 'text-matrix-accent font-semibold' : ''} data-id="element-427">
                {step}
              </p>)}
          </div>

          <p className="text-white text-lg mb-3" data-id="element-428">{t.finalCta.everyPage}</p>
          <p className="text-white text-lg font-medium mb-8" data-id="element-429">
            {t.finalCta.clearMessage}
          </p>

          <motion.p className="text-2xl md:text-3xl font-black text-matrix-accent text-glow mb-8" animate={{
          textShadow: ['0 0 10px rgba(0, 217, 255, 0.5), 0 0 20px rgba(0, 217, 255, 0.3)', '0 0 20px rgba(0, 217, 255, 0.8), 0 0 40px rgba(0, 217, 255, 0.5)', '0 0 10px rgba(0, 217, 255, 0.5), 0 0 20px rgba(0, 217, 255, 0.3)']
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-430">
            {t.finalCta.quote}
          </motion.p>

          <div className="space-y-4 mb-8" data-id="element-431">
            <p className="text-white text-xl font-bold" data-id="element-432">{t.finalCta.notWhat}</p>
            <p className="text-matrix-accent text-2xl font-black" data-id="element-433">
              {t.finalCta.youAre}
            </p>
          </div>

          <CTAButton size="large" className="mb-6" data-id="element-434">
            {t.finalCta.cta}
          </CTAButton>

          <p className="text-white text-sm" data-id="element-435">{t.finalCta.access}</p>
        </div>
      </Section>

      {/* Footer */}
      <footer className="py-6 border-t border-matrix-muted/20" data-id="element-436">
        <div className="container mx-auto px-4 text-center" data-id="element-437">
          <p className="text-sm" style={{
          color: '#00d2f7'
        }} data-id="element-438">
            © {new Date().getFullYear()}{' '}
            {language === 'es' ? 'ROMPE LA MATRIX' : 'BREAK THE MATRIX'} 3-6-9.{' '}
            {t.footer.rights}
          </p>
        </div>
      </footer>
    </main>;
}